import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Head } from '@_/components';

export const Route = createFileRoute('/{-$locale}/email-link_/_wrapper')({
  component: RouteComponent,
  ssr: false
});

function RouteComponent() {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <Outlet />
    </>
  );
}
